import Header from "./components/Header";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Scene from "./components/Scene";
import Trend from "./components/Trend";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      {/* 品牌 H1：首页以站点名作为唯一核心标题（视觉上由首屏大标题承担展示，此处保证语义层级） */}
      <h1 className="sr-only">国产吃瓜 · 瓜场今日瓜与现场快讯</h1>

      <Header />
      <main>
        <Hero />
        <Feed />
        <Scene />
        <Trend />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}